import { getParagraph, getExplain } from '../createRender';

let reverseParseTextView = data => {
    let obj = createRender(data);

    return obj;
}

function createRender(data) {
    if (!data.stem) {
        return {}
    }

    // 题干
    let stem = getParagraph(data.stem);
    // 答案
    let answer = data.answer ? getAnswer(data.answer) : null;
    // 解析
    let explain = data.explain ? getExplain(data.explain) : null;
    // 错误答案
    let wrong = data.wrongAnswer ? getWrongAnswer(data.wrongAnswer) : null;

    const render = { stem, answer, explain, wrong };
    return render;
}

const getAnswer = (answer) => {
    try {
        answer = JSON.parse(answer);
    } catch (error) {
        answer = [];
    }
    return !!answer ? '√' : '×';
};

/**
 * 获取错误答案
 */
const getWrongAnswer = wrong => {
    wrong.forEach(item => {
        const answer = JSON.parse(item.answer);
        item.answer = !!answer ? '√' : '×';
    });
    return wrong;
};

export { reverseParseTextView };


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/judge/createRender.js